<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <tab :arr="arr"></tab>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import tab from '@/components/tab';
export default {
  components: {
    tab,
  },
  props: ['id'],
  computed: {},
  data() {
    return {
      type: this.$route.path
        .split('/')
        .slice(0, 5)
        .join('/'),
      arr: [
        {
          name: '群发消息',
          url: `/third/${this.id}/mass/index`,
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
